import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Tooltip,
    Typography,
    Avatar,
    AvatarGroup,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from "@mui/material";

import { 
    Edit, 
    Delete, 
    Close,
    Workspaces,
    People,
    Videocam,
    Notes,
    AttachFile,
    ContentCopy,
} from "@mui/icons-material";
import { format } from "date-fns";

import { useSelector } from "react-redux";

// TODO: need to test this
const EventDialog = ({ event, open, handleClose, handleEdit, handleDelete }) => {
    const allWorkspaces = useSelector((state) => state.auth.user.allWorkspaces);
    console.log("EventDialog", event);
    const { title, start, end, allDay, source, description, attendees, attachments, link, id, profilePicturePath, workspaceId } = event;

    return (
        <Dialog open={open} onClose={handleClose} hideBackdrop>
            {/* if title exists, display title, else display "Untitled Event" */}
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box display="flex" flexDirection="column" mr="4rem">
                        {/* Title */}
                        <Typography variant="h3">{title || "(no title)"}</Typography>
                        {/* DateTime */}
                        {allDay ? (
                            <Typography variant="body2" color="text.secondary">
                                {format(new Date(start), 'MMM dd, yyyy')} - {format(new Date(end), 'MMM dd, yyyy')}
                            </Typography>
                        ) : (
                            <Box display="flex" gap="0.5rem">
                                <Typography variant="body2" color="text.secondary">
                                    {format(new Date(start), 'MMM dd, yyyy')}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    &#183;
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {format(new Date(start), 'h:mm aaa')} - {format(new Date(end), 'h:mm aaa')}
                                </Typography>
                            </Box>
                        )}   
                    </Box>
                    
                    {/* Edit and Delete buttons */}
                    <Box display="flex">
                        <Tooltip title="Edit Event" placement="bottom">
                            <IconButton onClick={handleEdit} >
                                <Edit fontSize="small"/>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Event" placement="bottom">
                            <IconButton onClick={handleDelete} >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Close" placement="bottom" sx={{ ml: "1rem" }}>
                            <IconButton onClick={handleClose} >
                                <Close fontSize="small"/>
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </DialogTitle>

            <DialogContent>
                <Box display="flex" flexDirection="column" gap="1.5rem">
                    {description && <Typography variant="body1">{description}</Typography> }

                    { /* workspace */}
                    <Box display="flex" gap="1rem" alignItems="center">
                        <Workspaces fontSize="small" />
                        <Box display="flex" alignItems="center" gap="0.5rem">
                            <Avatar 
                                src={allWorkspaces[workspaceId].profilePicturePath} 
                                sx={{ width: 24, height: 24 }} 
                            />
                            <Typography 
                                variant="secondary"
                                whiteSpace="nowrap"
                                overflow="hidden"
                                textOverflow="ellipsis"
                            >
                                {allWorkspaces[workspaceId].email}
                            </Typography>
                        </Box>
                    </Box>

                    { /* link */}
                    {link && (
                        // show button to join virtual conference
                        <Box display="flex" gap="1rem" alignItems="center">
                            <Videocam fontSize="small" />

                            <Box display="flex" gap="1rem">
                                <Button
                                    variant="contained"
                                    sx={{ textTransform: 'none' }}
                                    href={link} 
                                    target="_blank"
                                    //color={third_party_constants[virtualConferenceType].color}
                                >
                                    {//<Typography variant="secondary">{`Join on ${third_party_constants[virtualConferenceType].name}`}</Typography>
                                    }
                                    <Typography variant="secondary"> Join Meeting </Typography>
                                </Button>

                                <Box display="flex" alignItems="center">
                                    <Tooltip title="Copy conference link">
                                        <IconButton onClick={() => 
                                            // copy link to clipboard
                                            navigator.clipboard.writeText(link)
                                        }>
                                            <ContentCopy fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>
                    )}

                    { /* attendees */ }
                    {attendees && (
                        <Box display="flex" gap="1rem" alignItems="center">
                            <People fontSize="small"/>

                            <AvatarGroup max={4}>
                                {attendees?.map((attendee) => (
                                    <Tooltip title={attendee.email} key={attendee.email}>
                                        <Avatar
                                            alt={attendee.name || attendee.email}
                                            src={attendee.photo}
                                            sx={{ width: 30, height: 30 }}
                                        />
                                    </Tooltip>
                                ))}
                            </AvatarGroup>
                        </Box>
                    )}

                    { /* Attachments */ }
                    {attachments && (
                        <Box display='flex' gap="1rem" alignItems='flex-start'>
                            <AttachFile fontSize="small"/>

                            <Box display="flex" flexDirection="column" gap="0.5rem" alignItems="flex-start">
                                {   attachments.length > 0 &&
                                    <List 
                                        dense 
                                        disablePadding
                                        sx={{
                                            overflow: 'auto',
                                            maxHeight: 165,
                                        }}
                                    >
                                        {attachments?.map((attachment, index) => (
                                            <ListItem 
                                                key={attachment.fileId}
                                                disablePadding
                                            >
                                                <ListItemButton
                                                    href={attachment.fileUrl}
                                                    target="_blank"
                                                >
                                                    <ListItemText primary={attachment.title} />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                }
                            </Box>
                        </Box>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default EventDialog;